/**
 * Trial-balance query keys.
 *
 * `locale` and `excludeClosing` are part of the key because they are part of the
 * **request**: account names are resolved server-side, and excluding closing
 * entries returns a different set of figures. Switching language, or switching
 * to the pre-close reading, is a different report — not a re-render of the one
 * already cached.
 */
export const TrialBalanceQueryKeys = {
    all: ['trial-balance'] as const,
    report: (asOf: string, locale: string, excludeClosing: boolean) =>
        [...TrialBalanceQueryKeys.all, asOf, locale, excludeClosing] as const,
};
